import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { authStateAtom } from '@root/entities/auth'
import { AuthState } from '@root/entities/auth'
import { PremiumPurchase } from '@root/widgets/desktop/premium-purchase'

import { PremiumPageContent } from './premium-page-content'
import { PremiumUnauthorizedContent } from './premium-unauthorized-content'

export const PremiumPage: React.FC = () => {
  const [authState] = useAtom(authStateAtom)

  if (AuthState.isInitial(authState)) {
    return <PremiumUnauthorizedContent />
  }

  return (
    <Root>
      <Body>
        <PremiumPurchase />
        <PremiumPageContent />
      </Body>
    </Root>
  )
}

const Root = styled.div`
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
`

const Body = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow: hidden;

  display: grid;
  grid-template-columns: 370px minmax(0, 1fr);
  padding: 10px;
  gap: 10px;
`
